import { BrowserOptions } from "@sentry/browser"
import * as Sentry from "@sentry/browser"
import { AppConfig } from "../Config"

const ERRORS_TO_IGNORE = []

export const SentryOpts: BrowserOptions = {
  dsn: AppConfig.sentry.dsn,
  environment: AppConfig.sentry.environment,
  release: AppConfig.sentry.release,
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.01,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: AppConfig.isDevMode ? 1.0 : 0.05,
  normalizeDepth: 5,
  debug: AppConfig.isDevMode,
  allowUrls: ["66north.com"],
  beforeSend(event, hint) {
    const error = hint?.originalException as Error

    for (const ignoreMessage of ERRORS_TO_IGNORE) {
      if (error?.message?.match(ignoreMessage)) {
        return null
      }
    }

    return event
  }
}

export const SentryServerOpts = {
  ...SentryOpts,
  normalizeDepth: 1
}
